/**
 * @file Photo Card Actions on Entitled Photos.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton } from 'react-share';

import CustomControl from '../global/CustomControl';
import {
  allowsDownloadWatermarkOption,
  socialShareEnabled,
  isPpd,
} from '../../util/album';
import { IMAGE_SIZE_CODE } from '../../constants/image-size-codes';
import DownloadPhotoButtonContainer from '../../containers/global/DownloadPhotoButtonContainer';
import DropdownMenu from '../global/DropdownMenu';
import { getAsset } from '../../util/assets';
import getConfig from '../../util/config';
import { removeHashes } from '../../util/text';
import Button from '../global/Button';

class EntitledPhotosPhotoActions extends Component {
  static propTypes = {
    photo: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      ),
      watermarked_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          web_gallery_price_per_photo: PropTypes.shape({
            value: PropTypes.number,
            currency: PropTypes.string,
          }),
        }),
      ),
    }),
    entitledPhotos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ),
    album: PropTypes.shape({
      hash_code: PropTypes.string,
      download_without_watermark: PropTypes.bool,
      print_without_watermark: PropTypes.bool,
      social_share_enabled: PropTypes.bool,
      watermark_config: PropTypes.shape({
        id: PropTypes.string,
      }),
      web_gallery_price_per_photo: PropTypes.shape({
        value: PropTypes.number,
      }),
    }),
    canPurchase: PropTypes.bool,
    onPurchase: PropTypes.func,
  };

  static defaultProps = {
    entitledPhotos: [],
  };

  state = {
    downloadWithWatermark: true,
  };

  onToggleWatermarkedDownload = event => {
    const value = event.target.checked;

    this.setState(() => ({
      downloadWithWatermark: value,
    }));
  };

  render() {
    const { downloadWithWatermark } = this.state;
    const {
      photo,
      album,
      entitledPhotos,
      canPurchase,
      onPurchase,
      ...toggleProps
    } = this.props;

    const isEntitledPhoto = entitledPhotos
      .map(({ id }) => id)
      .includes(photo.id);

    const hashCode = removeHashes(album.hash_code);

    return (
      <Fragment>
        {socialShareEnabled(album) && (
          <FacebookShareButton
            url={`${getConfig().app.baseUrl}/p/${photo.id}`}
            hashtag={hashCode && `#${hashCode}`}
            className="mr-1"
          >
            <img
              src={getAsset('/icon-facebook-circle.svg')}
              alt="Share on Facebook"
            />
          </FacebookShareButton>
        )}
        <DropdownMenu {...toggleProps}>
          {allowsDownloadWatermarkOption(album, isEntitledPhoto) && (
            <CustomControl
              type="checkbox"
              label="Include Logo"
              id={`dl-branding-${photo.id}`}
              checked={downloadWithWatermark}
              onChange={this.onToggleWatermarkedDownload}
              size="sm"
              className="mb-1"
            />
          )}
          <DownloadPhotoButtonContainer
            photoId={photo.id}
            photoSize={IMAGE_SIZE_CODE.LARGE2X}
            includeWatermark={downloadWithWatermark}
            btnSize="sm"
            btnBlock
          >
            Download Hi-Res
          </DownloadPhotoButtonContainer>
          {canPurchase && isPpd(album) && (
            <Button onClick={onPurchase} btnSize="sm" btnBlock className="mt-1">
              Purchase in other formats
            </Button>
          )}
        </DropdownMenu>
      </Fragment>
    );
  }
}

export default EntitledPhotosPhotoActions;
